<template>
  <v-container fluid>
    <v-row>
      <v-col class="text-start" cols="auto">
        <v-text-field label="Buscar cliente" hide-details dense outlined v-model="searchClient" clearable
          prepend-inner-icon="mdi-magnify"></v-text-field>
      </v-col>
      <v-col class="text-start" cols="auto">
        <!-- <v-text-field prepend-inner-icon="mdi-magnify" v-model="search" label="Buscar..." clearable>
        </v-text-field> -->
        <v-select label="# Elementos" :items="elementLength" outlined dense v-model="rowsPerPage"></v-select>
      </v-col>
      <v-col class="text-end">
        <v-menu offset-y :close-on-click="true" :close-on-content-click="false" v-model="filterMenu">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" v-bind="attrs" v-on="on">
              <v-icon left>mdi-filter</v-icon>
              Filtro
            </v-btn>
          </template>
          <v-card width="400px">
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-autocomplete label="Seleciona OP" dense outlined no-data-text="No se encontro OP" hide-details
                      item-text="serial" return-object :items="opList" prepend-inner-icon="mdi-magnify"
                      :search-input.sync="searchOP" v-model="filter.op" clearable :loading="retrievingOp">
                      <template v-slot:item="data">
                        <div>
                          {{ data.item.serial }} - {{ data.item.client }}
                        </div>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12" v-if="filter.op">
                    <v-autocomplete label="Seleciona Entrega" dense outlined return-object hide-details
                      no-data-text="No se encontro Entrega" prepend-inner-icon="mdi-magnify" item-text="serial"
                      :items="deliveryList" :search-input.sync="searchDelivery" :disabled="!filter.op"
                      v-model="filter.delivery" clearable :loading="retrievingDelivery">
                      <template v-slot:item="data">
                        <div>
                          Entrega {{ data.item.serial }}
                        </div>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12">
                    <v-autocomplete label="Selecciona el destino" dense outlined clearable type="text" item-text="name"
                      no-data-text="Dirección no encontrada" :items="addressList" return-object v-model="filter.address"
                      hide-details="" :loading="retrievingAddressList"
                      :search-input.sync="searchAddress"></v-autocomplete>

                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="warning" @click="cleanFilter()">Restaurar</v-btn>
              <v-btn color="primary" @click="applyFilter()">Aplicar</v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
      </v-col>
      <v-col cols="auto">
        <v-btn color="primary" @click="showAddDeliverySelectOPModal = true">
          <v-icon>mdi-package-variant-closed-check</v-icon>
          Agregar entrega
        </v-btn>
      </v-col>
      <v-col cols="auto">
        <v-btn color="primary" @click="showAddNewProductToDeliveryModal = true">
          <v-icon>mdi-plus</v-icon>
          Agregar producto
        </v-btn>
      </v-col>
      <v-col cols="auto">
        <v-btn color="primary" @click="fetchData">
          <v-icon>mdi-refresh</v-icon>
          Recargar
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-data-table fixed-header height="calc(100vh - (420px))" :headers="headers" :items="orderDeliveries"
          :items-per-page="rowsPerPage" no-data-text="No hay productos" loading-text="Cargando entregas..."
          :page.sync="page" hide-default-footer :loading="fetchingData" item-key="_id">
          <template #[`item.type`]="{ item }">
            <span v-if="item.type">
              {{ item.type.name }}
            </span>
            <span v-else>-</span>
          </template>
          <template #[`item.line`]="{ item }">
            <span v-if="item.moType && item.line">
              <div v-if="item.moType == 'bacteria'">
                <div v-if="item.name == 'Streptomyces griseoviridis'">AS</div>
                <div v-else>B{{ item.line }}</div>
              </div>
              <div v-if="item.moType == 'fungi'">H{{ item.line }}</div>
            </span>
            <span v-else>
              <span v-if="item.line">
                {{ item.line }}
              </span>
              <span v-else>-</span>
            </span>
          </template>
          <template #[`item.presentation`]="{ item }">
            <span v-if="item.productType != 'KIT'">{{
              item.presentation.name
            }}</span>
            <span v-else>-</span>
          </template>
          <template #[`item.status`]="{ item }">
            <span v-if="item.status == 'NOT_SUPPLY'"> No surtida </span>
            <span v-else-if="item.status == 'SUPPLIED'">
              <v-icon color="primary"> mdi-check-decagram </v-icon>
              Surtida
            </span>
            <span v-else-if="item.status == 'ASSIGNED'">
              <v-icon color="info"> mdi-archive-clock-outline </v-icon>
              Asignado
            </span>
            <span v-else-if="item.status == 'PAUSE'">
              <v-icon color="info"> mdi-pause-circle </v-icon>
              Pausado
            </span>
            <span v-else-if="item.status == 'CANCELED'">
              <v-icon color="error"> mdi-cancel </v-icon>
              Cancelado
            </span>

            <span v-else> No reconocido </span>
          </template>
          <template #[`item.createdAt`]="{ item }">
            <span>{{ dateFormat(item.createdAt) }}</span>
          </template>
          <template #[`item._id`]="{ item }">
            <v-menu :rounded="true" offset-y class="pa-0">
              <template v-slot:activator="{ attrs, on }">
                <v-btn class="white--text" v-bind="attrs" v-on="on" text x-small>
                  <v-icon color="black"> mdi-dots-vertical </v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="handleUpdateProduct(item)">
                  <v-list-item-title> Actualizar </v-list-item-title>
                </v-list-item>
                <v-list-item @click="handleDeleteProduct(item)">
                  <v-list-item-title>Eliminar </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </v-data-table>
        <v-pagination v-model="page" :length="numPages" :total-visible="rowsPerPage" color="primary"></v-pagination>
      </v-col>
    </v-row>
    <AddNewProductToDeliveryModal v-model="showAddNewProductToDeliveryModal" v-if="showAddNewProductToDeliveryModal"
      @addProduct="handleAddProduct" />
    <UpdateProductToDeliveryModal v-model="showUpdateProductToDeliveryModal" v-if="showUpdateProductToDeliveryModal"
      @updateProduct="handlePoductUpdated" />
    <DeleteProductModal v-model="showDeleteProductModal" v-if="showDeleteProductModal"
      @deleteProduct="hangleProductDeleted" />
    <AddDeliverySelectOPModal v-model="showAddDeliverySelectOPModal" v-if="showAddDeliverySelectOPModal"
      @update="handleDeliveryAdded" />
  </v-container>
</template>

<script>
//vuex
import { mapActions, mapMutations, mapState } from "vuex";
//axios
import axios from "axios";
//validations
import { requiredValidation, requiredMultiple } from "@/helpers/validations.js";
// date library
import dayjs from "dayjs";
//components
import AddDeliveryOP from "@/components/dashboard/production-orders/modals/AddDeliveryOP.vue";
import NotificationModal from "@/components/dashboard/production-orders/modals/NotificationModal.vue";
import UpdateDelivery from "@/components/dashboard/production-orders/modals/UpdateDelivery.vue";
import AddNewProductToDeliveryModal from "../modals/AddNewProductToDeliveryModal.vue";
import UpdateProductToDeliveryModal from "../modals/UpdateProductToDeliveryModal.vue";
import DeleteProductModal from "../modals/DeleteProductModal.vue";
import AddDeliverySelectOPModal from "../modals/AddDeliverySelectOPModal.vue";

export default {
  components: {
    AddDeliveryOP,
    NotificationModal,
    UpdateDelivery,
    AddNewProductToDeliveryModal,
    UpdateProductToDeliveryModal,
    DeleteProductModal,
    AddDeliverySelectOPModal,
  },
  data: () => ({
    isLoading: false,
    user: JSON.parse(localStorage.getItem("user")),
    showAddDeliveryOP: false,
    showNotificationModal: false,
    showUpdateDelivery: false,
    client: null,
    saleType: null,
    label: null,
    saleTypes: [
      { name: "R", value: "R" },
      { name: "OP", value: "OP" },
      { name: "P", value: "P" },
      { name: "OR", value: "OR" },
      { name: "I", value: "I" },
      { name: "M", value: "M" },
      { name: "KIT", value: "KIT" },
    ],
    headers: [
      { text: "Entrega", align: "start", value: "serial", sortable: false },
      { text: "Nombre", align: "start", value: "name", sortable: false },
      { text: "Tipo", value: "productType", sortable: false },
      {
        text: "Cantidad",
        align: "center",
        value: "qty",
        sortable: false,
      },
      {
        text: "Linea",
        align: "center",
        value: "line",
        sortable: false,
      },
      {
        text: "Presentación",
        align: "center",
        value: "presentation",
        sortable: false,
      },
      {
        text: "Fecha de entrega producción",
        align: "center",
        value: "deliveryProductionDate",
        sortable: false,
      },
      {
        text: "Estatus",
        align: "center",
        value: "status",
        sortable: false,
      },
      {
        text: "Acciones",
        align: "center",
        value: "_id",
        sortable: false,
      },
    ],
    orderDeliveries: [],
    fetchingData: false,
    page: 1,
    search: null,
    numPages: 1,
    expanded: [],
    filterMenu: null,
    filter: {
      op: null,
      delivery: null,
      // client: null,
      address: null
    },
    elementLength: [8, 10, 15, 20, 50, 100],
    rowsPerPage: 10,
    showAddNewProductToDeliveryModal: false,
    searchOP: null,
    opList: [],
    searchDelivery: null,
    deliveryList: [],
    addressList: [],
    searchAddress: null,
    retrievingOp: false,
    retrievingDelivery: false,
    retrievingAddressList: false,
    searchClient: null,
    showUpdateProductToDeliveryModal: false,
    showDeleteProductModal: false,
    showAddDeliverySelectOPModal: false
  }),
  props: {
    tab: Number,
  },
  computed: {
    ...mapState("order", ["orderToUpdate", "calendarSelection"]),
  },
  async created() {
    await this.fetchData();
    await this.getAddressList()
  },
  methods: {
    ...mapActions("order", [
      "getDeliverytOrders",
      "updateOP",
      "sendNotificationLoteEvent",
      "getProductsListAll",
      "getDeliveryBySerial",
      "getOrderBySerial"
    ]),
    ...mapActions("address", ["getAddress"]),
    ...mapMutations("order", ["SET_DELIVERY_OP_TO_UPDATE", "SET_PRODUCT_SELECTED", "SET_CALENDAR_SELECTION"]),
    async updateOPRequest() {
      //emit fetch table
      if (this.$refs.loteForm.validate()) {
        try {
          this.isLoading = true;
          let payload = {
            client: this.client,
            user: this.user,
            saleType: this.saleType.value,
            label: this.label,
            order: this.orderToUpdate._id,
          };

          let response = await this.updateOP(payload);
          if (response) {
            this.$swal({
              icon: "success",
              title: `OP actualizada`,
              showConfirmButton: false,
              timer: 1000,
            });
            this.$emit("update");
          } else {
            this.$swal({
              icon: "error",
              title: `Algo salio mal al actualizar OP`,
              showConfirmButton: false,
              timer: 2000,
            });
          }
        } catch (e) {
          console.log(e);
          this.$swal({
            icon: "error",
            title: `Algo salio mal al actualizar OP`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
        this.isLoading = false;
      }
    },
    async fetchData() {
      try {
        this.fetchingData = true;
        let payload = {
          page: this.page,
          search: this.searchClient,
          rowsPerPage: this.rowsPerPage,
          filter: {
            op: this.filter.op ? this.filter.op._id : null,
            delivery: this.filter.delivery ? this.filter.delivery._id : null,
            client: this.filter.client,
            address: this.filter.address ? this.filter.address._id : null,
          },
          // order: this.orderToUpdate._id,
        }
        if (this.calendarSelection) {
          payload.filter.delivery = this.calendarSelection.delivery
          payload.filter.op = this.calendarSelection.order
          this.SET_CALENDAR_SELECTION(null)
        }
        let response = await this.getProductsListAll(payload);

        if (response) {
          if (!response.error) {
            this.orderDeliveries = response.ordersFound;
            // this.SET_ORDER_EVENTS(response.orders);
            this.numPages = response.totalPages;
          } else {
            this.$swal({
              icon: "error",
              title: `Algo salio mal al cargar ordenes`,
              showConfirmButton: false,
              timer: 2000,
            });
          }
        } else {
          this.$swal({
            icon: "error",
            title: `Algo salio mal al cargar ordenes`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
      } catch (error) {
        console.log(error);
        this.$swal({
          icon: "error",
          title: `Algo salio mal al cargar ordenes`,
          showConfirmButton: false,
          timer: 2000,
        });
      }
      this.fetchingData = false;
    },
    updateDelivery(item) {
      if (item) {
        this.showUpdateDelivery = true;
      } else {
        this.showAddDeliveryOP = true;
      }
      this.SET_DELIVERY_OP_TO_UPDATE(item);
    },
    async updateData() {
      await this.fetchData();
      this.showAddDeliveryOP = false;
    },
    validation(name) {
      return requiredValidation(name);
    },
    dateFormat(value) {
      if (value) {
        const date = `${dayjs(value).format("DD-MM-YYYY - HH:mm")} hrs`;
        return date ? date : "-";
      } else {
        return "-";
      }
    },
    async cleanFilter() {
      this.filterMenu = false;
      this.filter = {
        op: null,
        delivery: null,
        client: null,
        address: null
      }
      this.opList = []
      this.deliveryList = []
      this.addressList = []
      await this.fetchData()
    },
    async applyFilter() {
      this.filterMenu = false;
      await this.fetchData()
    },
    async handleAddProduct() {
      this.showAddNewProductToDeliveryModal = false
      await this.fetchData()
    },
    handleUpdateProduct(product) {
      this.SET_PRODUCT_SELECTED(product)
      this.showUpdateProductToDeliveryModal = true
    },
    async handlePoductUpdated() {
      this.SET_PRODUCT_SELECTED(null)
      this.showUpdateProductToDeliveryModal = false
      await this.fetchData()
    },
    handleDeleteProduct(product) {
      this.SET_PRODUCT_SELECTED(product)
      this.showDeleteProductModal = true
    },
    async hangleProductDeleted() {
      this.SET_PRODUCT_SELECTED(null)
      this.showDeleteProductModal = false
      await this.fetchData()
    },
    async handleDeliveryAdded() {
      this.showAddDeliverySelectOPModal = false
      await this.fetchData()
    },
    async getAddressList() {
      try {
        this.retrievingAddressList = true
        let payload = {
          search: this.searchAddress,
          rowPerPage: 20
        }
        let response = await this.getAddress(payload)
        this.addressList = response.addressList
      } catch (error) {
        console.log(error);
      } finally {
        this.retrievingAddressList = false
      }
    }
  },
  watch: {
    async search() {
      this.page = 1;
      this.fetchData();
    },
    async page() {
      await this.fetchData();
    },
    async rowsPerPage() {
      this.page = 1;
      await this.fetchData();
    },
    async searchOP() {
      if (!this.searchOP || this.filter.op) return
      try {
        this.retrievingOp = true
        let payload = {
          serial: this.searchOP
        }
        let response = await this.getOrderBySerial(payload)
        this.opList = response.orders
      } catch (error) {
        console.log("searchOP", error);
      } finally {
        this.retrievingOp = false
      }
    },
    async searchDelivery() {
      if (!this.searchDelivery || this.filter.delivery) return
      try {
        this.retrievingDelivery = true
        let payload = {
          serial: this.searchDelivery,
          order: this.filter.op._id,
        }
        let response = await this.getDeliveryBySerial(payload)
        this.deliveryList = response.deliveries
      } catch (error) {
        console.log(error);
      } finally {
        this.retrievingDelivery = false
      }
    },
    async searchAddress() {
      await this.getAddressList()
    },
    async searchClient() {
      this.page = 1;
      await this.fetchData();
    },
    async tab() {
      if (this.tab == 0) {
        await this.fetchData();
      }
    },
    async calendarSelection() {
      if (!this.calendarSelection) return
      this.$emit("changeTab")
      await this.fetchData()
    }
  },
};
</script>

<style scoped>
.decrease {
  background-color: red;
  color: white;
}
</style>